export default [
	{
		start: 0.05,
		end: 3,
		text: 'Nouveau message reçu d\'un Hiver de rang 9.'
	}
]
